import { createRouter } from '../Router.mjs';

const { RouterProvider: OrgSettingsRouterProvider, Router: OrgSettingsRouter, useRouterController: useOrgSettingsRouterController} = createRouter();

export { OrgSettingsRouter, OrgSettingsRouterProvider, useOrgSettingsRouterController };
//# sourceMappingURL=AdminPortalOrgRouter.mjs.map
